import { createRouter, createWebHashHistory } from 'vue-router'

import Home from '@/views/Home'
import Company from '@/views/Company'
import Person from '@/views/Person'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/company',
    name: 'Company',
    component: Company
  },
  {
    path: '/person',
    name: 'Person',
    component: Person
  }
]

export default createRouter({
  history: createWebHashHistory('./'),
  // history: createWebHashHistory('/21h5/'),
  routes
})
